import OutletsOld from './OutletsOld';

export default OutletsOld;
